export default {"src":"/_next/static/media/WhoWeAre_006A.40714819.JPG","height":708,"width":1920};